/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     NAME: converters.ts
   AUTHOR: Harikrishnan Gangadharan
 COMMENTS: 

/***************************************************************************************************************************
 IMPORTS
****************************************************************************************************************************/
import {
  DocumentData,
  QueryDocumentSnapshot,
  SnapshotOptions,
  WithFieldValue
} from 'firebase/firestore';
/***************************************************************************************************************************
 CLASSES / FUNCTIONS
****************************************************************************************************************************/
const JobPost = {
  toFirestore(post: WithFieldValue<JobPosting>): DocumentData {
    return {
      id: post.id,
      position: post.position,
      location: post.location,
      type: post.type
    };
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): JobPosting {
    const data = snapshot.data(options)!;
    return {
      id: data.id,
      position: data.position,
      location: data.location,
      type: data.type
    };
  }
};

const Testimonial = {
  toFirestore(testimonial: WithFieldValue<Testimonial>): DocumentData {
    return {
      id: testimonial.id,
      name: testimonial.name,
      role: testimonial.role,
      org: testimonial.org,
      comments: testimonial.comments
    };
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): Testimonial {
    const data = snapshot.data(options)!;
    return {
      id: data.id,
      name: data.name,
      role: data.role,
      org: data.org,
      comments: data.comments
    };
  }
};

const Converters = {
  JobPost,
  Testimonial
};

export default Converters;
